import React from 'react';
import { RiCloseFill, RiErrorWarningFill } from 'react-icons/ri';
import './alertmodal.css';
import Swal from 'sweetalert2';
export function WarningAlert({ message, ondelete, onCancel }) {
  Swal.fire({
    title: 'Are you sure?',
    html: message,
    icon: 'warning',
    showConfirmButton: true,
    showCancelButton: true,
    preConfirm: ondelete,
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
    preDeny: onCancel(),
    confirmButtonColor: '#2aa2db',
    cancelButtonColor: '#d33',
    // onCancel: onCancel(),
  });

  return null;
  // <div>
  //   <div className="overlay">
  //     <div
  //       className="popupWarning d-flex justify-content-between  align-items-center"
  //       style={{
  //         backgroundColor: '#f9f4c4',
  //         borderWidth: 2,
  //         borderColor: '#ddd78e',
  //       }}
  //     >
  //       <div className="d-flex justify-content-start">
  //         <div className="alert_modal-header d-flex align-items-center input_item justify-content-center">
  //           <RiErrorWarningFill size={40} fill="#FFC145" />
  //         </div>
  //         <div style={{ paddingLeft: 10 }}>
  //           <div
  //             className="pb-0 mb-0"
  //             style={{ color: '#967430', fontSize: 17 }}
  //           >
  //             {'WARNING!'}
  //           </div>
  //           <div style={{ lineHeight: 1, color: '#af915c' }} className="  ">
  //             {message}
  //           </div>
  //         </div>
  //       </div>
  //       <div>
  //         <div
  //           onClick={onCancel}
  //           style={{
  //             width: 30,
  //             height: 30,
  //             position: 'absolute',
  //             right: -5,
  //             top: 0,
  //           }}
  //         >
  //           <RiCloseFill size={20} color={'#af915c'} />
  //         </div>
  //         <div onClick={ondelete} style={{ width: 30, height: 30 }}>
  //           <div style={{ color: '#967430', fontSize: 15 }}>Yes</div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // </div>
}
